import { createContext, useContext } from 'react';

// Contexto de rol admin. Extraido de App.js (v37.0) para romper el ciclo
// de imports App <-> NavBar. App.js provee el value; NavBar/Hub/RequireAdmin
// lo consumen via useAdmin().
export const AdminContext = createContext(false);
export const useAdmin = () => useContext(AdminContext);
